export const Config = {
  maximumNumberOfCartsLoggedIn: 200,
  maximumNumberOfCartsNotLoggedIn: 50,
  perPage: 10,
  volumesPerPage: 30,
  bulkPurchaseTitlesPerPag: 20,
}
